import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.')
    },
    registered(registration) {
      console.log('Service worker has been registered.')
      // A tab left open for hours never navigates, so the browser never checks
      // for a new SW and the tab keeps running the build it booted with. Ask
      // explicitly when the tab regains focus, and hourly while it stays open.
      const checkForUpdate = () => registration.update().catch(() => {})
      window.addEventListener('focus', checkForUpdate)
      setInterval(checkForUpdate, 60 * 60 * 1000)
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      // The SW calls skipWaiting()/clientsClaim(), so the new build is already
      // in control of future requests — but this tab is still running the old
      // JS until it reloads. Surfacing it lets the app offer that reload.
      console.log('New content is available; please refresh.')
      // The flag covers the case where this fires before the listening
      // component is mounted; the event covers everything after that.
      window.__swUpdatePending = true
      window.dispatchEvent(new CustomEvent('sw:updated'))
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
  })
}
